import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/services/administration/analytics.service';
import { UserService } from 'src/app/services/user.service';
import * as $ from 'jquery';
declare const initComposerEmbedManager: any;

@Component({
  selector: 'app-analytic-scheduler',
  templateUrl: './analytic-scheduler.component.html',
  styleUrls: ['./analytic-scheduler.component.scss']
})
export class AnalyticSchedulerComponent implements OnInit,OnDestroy {

  user_Org_Accesstoken:String = "";

  constructor(private userService: UserService,public analyticsService: AnalyticsService) { }
  
  ngOnInit(): void {
    this.getUserAccesstoken()
  }

 ngOnDestroy(): void {
  const elements = document.getElementsByClassName("embedDash")[0];
  elements.innerHTML = "";
  $("#embedDash").empty();
 }
  getUserAccesstoken(){

    var ORGCODE = this.userService.getOrgCode();

    this.analyticsService.getDataById("api/Analytics/GetUserOrgAccesstoken/", ORGCODE).subscribe(response => {
      if (response.Status != undefined && response.Status == 0) {
        this.user_Org_Accesstoken = response.Data;
        this.LoadLibrary();
      } else {        
        this.user_Org_Accesstoken = "";
      }
    });
  }

  LoadLibrary() {
    //this.getUserAccesstoken();
    const elements = document.getElementsByClassName("embedDash")[0];
    elements.innerHTML = "";
    const getEmbedManagerPromise =
      initComposerEmbedManager({
        initialToken: this.user_Org_Accesstoken 
      });

    getEmbedManagerPromise.then((embedManager: any) => {
      embedManager.createComponent('inventory',
        {
          "type": "inventory",
          "inventoryItem": "dashboard",
          "theme": "modern",
          "interactivityOverrides": {
            "settings": {
              "SCHEDULE": true
            }
          },
          "components": {
            "actions": {
              "visible": false
            },
            "table": {
              "defaultSort": {
                "colId": "name", // ["favorite", "name", "dataSource", "author", "dateModified", "permissions", "schedule", "actions"]
                "sortDirection": "asc"
              },

              "columns": {
                "showDefaults": true,

                "order": [
                  "favorite",
                  "name",
                  //"newColumn",
                  //"dataSource",
                  "author",
                  "dateModified",
                  //"permissions",
                  "schedule",
                  //"actions"
                ],
                "visibility": [
                  "favorite",
                  "name",
                  //"newColumn",
                  //"dataSource",
                  "author",
                  "dateModified",
                  //"permissions",
                  "schedule",
                  //"actions"
                ]
              }
            }
          }
        }
      ).then((dashboard: any) => dashboard.render(
        document.getElementById("embedDash"), // htmlElement
        { width: '100%', height: '100%' }
      ))
    });

  }
}
